'use strict';

app.directive('rmDatepicker', function () {
  return {
    replace: true,
    scope: {
      model: '=rmDatepicker',
      required: '='
    },
    templateUrl: '/app/directives/rm-datepicker/rm-datepicker.html',
    controller: function ($scope) {
      $scope.open = function ($event) {
        $event.stopPropagation();
        $scope.isOpen = true;
      };
    }
  };
});
